export default __webpack_public_path__ + "assets/images/4d076c666137854bf51201661e7ba6ef.png";